import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    entryVehicleContent: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: theme.spacing(1),
      flexWrap: "wrap",
    },
    entryVehicleSearch: {
      width: 320,
      maxWidth: "100%",
    },
    // Con el vehículo elegido la tarjeta resumen ocupa todo el ancho disponible.
    entryVehicleSelected: {
      width: "100%",
    },
    entryVehicleResults: {
      width: "100%",
      marginTop: theme.spacing(0.5),
    },
    entryVehicleAddOption: {
      marginTop: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "#187b3a",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#12632e",
      },
      "& .MuiListItemText-primary": {
        color: "#fff",
        fontWeight: 600,
      },
    },
  })
);
